export const urlNOFS = "https://www.twistedtech.wtf/nofs/mint";
export const urlTUNE = "https://www.twistedtech.wtf/launchpad/tune/mint";
// note: if trying to use these against other locally hosted urls, drop the "s" of https
// when you get that error that makes no sense.